import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { collectorRequest, type CollectorPreferences } from '../services/api/collector';
export function useCollectorPreferences() {
  const { user } = useAuth();
  const [state, setState] = useState<{ owner: number; value: CollectorPreferences } | null>(null);
  useEffect(() => {
    let current = true;
    const load = () => {
      if (user)
        void collectorRequest<CollectorPreferences>('settings')
          .then((value) => {
            if (current) setState({ owner: Number(user.id), value });
          })
          .catch(() => {
            if (current) setState(null);
          });
    };
    load();
    window.addEventListener('collector-preferences-changed', load);
    return () => {
      current = false;
      window.removeEventListener('collector-preferences-changed', load);
    };
  }, [user]);
  return state?.owner === Number(user?.id) ? state?.value : null;
}
